import { TalkdeskChatButton } from 'apps/acp/packages/talkdesk-chatbot';
import { usePermissions } from './permissions';
import { AdaChatButton } from 'apps/acp/packages/ada-chatbot';
import { createElement } from 'react';
export const Chatbot = () => {
  const {
    isTalkdeskEnabled
  } = usePermissions();
  return isTalkdeskEnabled ? createElement(TalkdeskChatButton, {
    authed: true
  }) : createElement(AdaChatButton, {
    authed: true
  });
};